// Frittstående personregister-vindu (poppet ut). Ingen feed nødvendig — leser
// og skriver via /admin/brukere + /admin/medlemskap/* (sesjons-cookie, hubben
// håndhever RBAC og kanVerifisere server-side).
import type { User } from '@skade/rbac';
import type { Feed } from '../data/feed.js';
import type { SyncBus } from '../sync.js';
import { PersonregisterPanel, personregisterHent, personregisterSend } from '../ui/personregister.js';

export function mountPersonregisterPanel(root: HTMLElement, _feed: Feed, _sync: SyncBus, _user: User): void {
  document.body.classList.add('panel-standalone');
  root.innerHTML = '';
  const panel = new PersonregisterPanel({ hent: personregisterHent, send: personregisterSend });
  panel.el.classList.add('open', 'embedded');
  root.append(panel.el);
}
